'use client';

import dynamic from 'next/dynamic';

export const FullBleedGrid = dynamic(() => import('./FullBleedGrid'));
